/**
 * Created by carlos on 23/10/2024.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('revenueProductionFlightsSsr',{
                parent: 'app',
                url: '/revenueProductionFlightsSsr?page&size&departureDate&classificationSsrId',
                params: {
                    page: "0",
                    size: "50",
                    departureDate: null,
                    classificationSsrId: "-1"
                },

                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/revenue/revenueProductionSsr/revenueProductionsSsr.html',
                        controller: 'revenueProductionSsrCtrl',
                        controllerAs: 'vm',
                        'resolve': {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['revenuePlanning']);
                            }],
                            'tabRevenue': ['tabService', function(tabService){
                                return tabService.getTabRevenue('revenueProductionFlightsSsr')
                            }],
                            ssrS: ['itineraryService','$stateParams', function(itineraryService,$stateParams){
                                return itineraryService.getSsrS(false);
                            }],
                            classifications: ['classificationSsrService','$stateParams', function(classificationSsrService,$stateParams){
                                return classificationSsrService.getClassificationListSsr();
                            }],
                            flights: ['itineraryService','$stateParams', function (itineraryService,$stateParams) {
                                if ($stateParams.departureDate == null) {
                                    $stateParams.departureDate = (new Date()).getTime();
                                }
                                return itineraryService.getRevenueByDateSsr($stateParams.departureDate, $stateParams.classificationSsrId, $stateParams.page, $stateParams.size);
                            }]
                        }
                    }
                }
            })
    }
})();


